import { Container, Grid } from '@mui/material'
import { CraneSplitActions } from '@operations/features/craneSplit/components/CraneSplitActions/CraneSplitActions'
import { CraneSplitContainer } from '@operations/features/craneSplit/containers/CraneSplitContainer'
import { CraneSplitDialogContainer } from '@operations/features/craneSplit/containers/CraneSplitDialogContainer'
import { CraneSplitErrorMessageContainer } from '@operations/features/craneSplit/containers/CraneSplitErrorMessageContainer'
import { SelectCranesDialog } from '@operations/features/craneSplit/containers/SelectCranesDialog'
import { observer } from 'mobx-react-lite'
import { useMinimalsTheme } from 'modules/ui/src/hooks/use-minimals-theme.hook'
import { EquipmentPlanningUIStore } from '../../stores/equipment-planning-ui-store'

interface Props {
  equipmentPlanningUIStore: EquipmentPlanningUIStore
  remarks?: string
}
export const CraneSplitContent = observer(({ equipmentPlanningUIStore, remarks }: Props) => {
  const theme = useMinimalsTheme()

  return (
    <Container
      sx={
        equipmentPlanningUIStore.craneSplitContainerUIStore.isExporting
          ? { my: 0, p: '0 !important' }
          : { my: theme.customSpacing.m }
      }
    >
      {!equipmentPlanningUIStore.craneSplitContainerUIStore.isExporting && (
        <Grid container>
          <Grid
            sx={{ mb: theme.customSpacing.m, display: 'flex', justifyContent: 'end' }}
            size={12}
          >
            <CraneSplitActions
              uiDialogStore={equipmentPlanningUIStore.craneSplitDialogUIStore}
              uiContainerStore={equipmentPlanningUIStore.craneSplitContainerUIStore}
              uiSelectCranesDialogStore={equipmentPlanningUIStore.selectCranesDialogUIStore}
            />
          </Grid>
          <CraneSplitErrorMessageContainer
            uiStore={equipmentPlanningUIStore.craneSplitMessageUIStore}
          />
        </Grid>
      )}
      <CraneSplitContainer
        uiContainerStore={equipmentPlanningUIStore.craneSplitContainerUIStore}
        uiDialogStore={equipmentPlanningUIStore.craneSplitDialogUIStore}
      />
      <CraneSplitDialogContainer
        uiStore={equipmentPlanningUIStore.craneSplitDialogUIStore}
        craneSplitContainerUIStore={equipmentPlanningUIStore.craneSplitContainerUIStore}
      />
      <SelectCranesDialog
        uiStore={equipmentPlanningUIStore.selectCranesDialogUIStore}
        uiMessageStore={equipmentPlanningUIStore.craneSplitMessageUIStore}
        uiContainerStore={equipmentPlanningUIStore.craneSplitContainerUIStore}
        uiEquipmentPlanningStore={equipmentPlanningUIStore.equipmentPlanningEquipmentsUIStore}
        remarks={remarks}
      />
    </Container>
  )
})
